import { useState, useRef, useEffect } from 'react';

export interface SenderAccount {
    email: string;
    domain: string;
    displayName: string;
    dailySendLimit: number;
    sentToday: number;
}

export interface DomainConfig {
    countryCode: string;
    country: string;
    domain: string;
    senders: SenderAccount[];
}

const FLAGS: Record<string, string> = {
    ASIA: '🌏', EU: '🇪🇺', LAT: '🌎',
    US: '🇺🇸', CA: '🇨🇦', MX: '🇲🇽', AR: '🇦🇷', UY: '🇺🇾', BR: '🇧🇷',
    CO: '🇨🇴', CL: '🇨🇱', ES: '🇪🇸', FR: '🇫🇷', DE: '🇩🇪', GB: '🇬🇧',
    AE: '🇦🇪', SG: '🇸🇬', AU: '🇦🇺',
};

interface Props {
    accounts: DomainConfig[];
    selected: SenderAccount | null;
    onSelect: (sender: SenderAccount) => void;
}

export function AccountSwitcher({ accounts, selected, onSelect }: Props) {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const currentLabel = selected
        ? `${selected.displayName}`
        : "选择发件账号";

    return (
        <div className="account-switcher" ref={ref}>
            <button
                className="account-switcher-trigger"
                onClick={() => setOpen(!open)}
            >
                <span>📧</span>
                <span>{currentLabel}</span>
                <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>▾</span>
            </button>

            {open && (
                <div className="account-switcher-dropdown">
                    <div style={{ padding: '8px 12px', fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                        切换发件账号
                    </div>
                    {accounts.map((dc) => (
                        <div key={dc.domain}>
                            <div style={{ padding: '6px 12px', fontSize: 10, color: 'var(--text-dim)', fontWeight: 600 }}>
                                {FLAGS[dc.countryCode] || '🌍'} {dc.domain}
                            </div>
                            {dc.senders.map((s) => (
                                <button
                                    key={s.email}
                                    className={`account-option${selected?.email === s.email ? ' selected' : ''}`}
                                    onClick={() => { onSelect(s); setOpen(false); }}
                                >
                                    <div>
                                        <div className="account-email">{s.email}</div>
                                        <div className="account-domain">{s.displayName} · {s.sentToday}/{s.dailySendLimit} 今日已发送</div>
                                    </div>
                                </button>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
